import { FC } from 'react'
import { TextArea } from '@progress/kendo-react-inputs'

export interface HomeInformationProps {
  header: string
  information: string
}

export const HomeInformationDisplay: FC<HomeInformationProps> = (props) => {
  return (
    <>
      <h3>{props.header}</h3>
      <TextArea rows={4} value={props.information} readOnly />
    </>
  )
}
